import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Mosaico = () => {
  return (
    <Container fluid>
      <Row xs={1} sm={2} md={3} lg={4} xl={4} className="g-4">
        {itemData.map((item) => (
          <Col key={item.img}>
            <div className="image-item">
              <img
                src={`${item.img}?w=300&h=300&fit=crop&auto=format`}
                srcSet={`${item.img}?w=300&h=300&fit=crop&auto=format&dpr=2 2x`}
                alt={item.title}
                loading="lazy"
                style={{ width: '100%', height: '100%' }}
              />
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

const itemData = [
    {
        img: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMGQzNTQwOWQwMWNlODI3ZjZlOTVhNzYwOGFiNWMxMWI0Njk3NmViYSZlcD12MV9pbnRlcm5hbF9naWZzX2dpZklkJmN0PWc/ZBfwzPRLhRlkx7PE0l/giphy.gif',
        title: 'Dia Naranja',
      },
      {
        img: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExZjVjNTNjZmIyYTk1NGIyZDdiYjgzNWI1NThmYTk5ZDRmMmFiMTQ0NSZlcD12MV9pbnRlcm5hbF9naWZzX2dpZklkJmN0PWc/DEYViIE8uFz7585QWu/giphy.gif',
        title: 'Colibri',
      },
      {
        img: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMmMxZmE5MzRiMzYwNzIxMDkyMzExNWU3YjRmOGRiMzkzNGViM2I5NiZlcD12MV9pbnRlcm5hbF9naWZzX2dpZklkJmN0PWc/RkZ9DiOJhjbhirvKXT/giphy.gif',
        title: 'Galeria3',
      },
      {
        img: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExNzBiOTE3MTgyYTE2YmM4YjkxNWU3OWI2NjZmNjZjNjUwNjI1YWRmYSZlcD12MV9pbnRlcm5hbF9naWZzX2dpZklkJmN0PWc/hO5OD71FW328FsRdPf/giphy.gif',
        title: 'Venadito',
      },
      {
        img: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExNGFlMTc0ZDcxMjY0MmQxZTNlYWRjODBkNTdiMjlkNDcyMDM3NmVmZSZlcD12MV9pbnRlcm5hbF9naWZzX2dpZklkJmN0PWc/o0Qed0j0QvFtqybPqJ/giphy.gif',
        title: 'Integridad',
      },
     
      {
        img: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExNDM0MTYzMGNlZjUwYTdkZWI4NTRmODBmOWY3YmE4NTQzYTg5NzFmNSZlcD12MV9pbnRlcm5hbF9naWZzX2dpZklkJmN0PWc/xtpVt7Tsp2HoWbBtVN/giphy.gif',
        title: 'Galeria2',
      },
      {
        img: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExZWIyYjA4ZmYxYTc4OTY5OWRiZDU1NTY0NDQwMzdiYjQ3MTM0NTU3ZCZlcD12MV9pbnRlcm5hbF9naWZzX2dpZklkJmN0PWc/Q2fv9PnZMQxVmHzs4w/giphy.gif',
        title: 'Logo1',
      },
      {
        img: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExZWZjZjI5MDYyNjE0NTg4MWQwNzY5YzU3NmM2YTU3ZjZjZGRhY2IyNiZlcD12MV9pbnRlcm5hbF9naWZzX2dpZklkJmN0PWc/p0YPQxZBzBVils7WaW/giphy.gif',
        title: 'Breakfast',
      },

      /*
      {
        img: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMWIxZDlhZDljZWNmNDkyZDk1ZGFhYWY0YTQ4ODY5NjM2YjY3YThkNiZlcD12MV9pbnRlcm5hbF9naWZzX2dpZklkJmN0PWc/ZW8TAtSY5xxUIZSq9W/giphy.gif',
        title: 'Pajarito',
      },*/

];

export default Mosaico;
